import { render, staticRenderFns } from "./emailMsgModal.vue?vue&type=template&id=41fbf6ce&"
import script from "./emailMsgModal.vue?vue&type=script&lang=js&"
export * from "./emailMsgModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports